<template>
    <CompassDialog
        :visible.sync="visible"
        :title="title"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        @closed="handleCancel"
    >
        <p class="typographies-paragraph-medium-regular">
            {{ message }}
        </p>
    </CompassDialog>
</template>

<script>
export default {
    data() {
        return {
            visible: true,
            title: this.$t.__('email.SettingsEmailsTemplatesWarningEditionModal.title'),
            message: this.$t.__('email.SettingsEmailsTemplatesWarningEditionModal.message'),
            parentVue: this.$parent.$refs.settingsEmailsTemplatesRef.__vue__,
        };
    },
    computed: {
        primaryAction() {
            return {
                label: this.$t.__(
                    'email.SettingsEmailsTemplatesWarningEditionModal.btn_label_leave_without_save',
                ),
                type: 'primary-destructive',
                action: () => this.handleLeaveWithoutSave(),
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    action: () => this.handleCancel(),
                },
            ];
        },
    },
    methods: {
        handleLeaveWithoutSave() {
            this.parentVue.handleCancel();
            this.handleCancel();
        },
        handleCancel() {
            this.parentVue.showWarningEditionModal = false;
            this.$emit('close');
        },
    },
};
</script>
